import { Lang } from "../Types/Lang";
import { Title } from "../Types/Title";


type Probs = {
    title: Title;
    lang: Lang
};

export const TitleComponent = ({ title, lang }: Probs) => {
    return (
        <div className="space-y-1">
            <h1 className="cv-title">{title.title[lang]}</h1>
            <h2 className="cv-heading">{title.subtitle?.[lang]}</h2>
        </div>
    );
}